import AssignmentRepeatInput from './AssignmentRepeatInput';

export default AssignmentRepeatInput;
